import secureLocalStorageModule from "react-secure-storage";

const secureLocalStorage = (secureLocalStorageModule as unknown as {default?: typeof secureLocalStorageModule}).default ?? secureLocalStorageModule;
import { UserInterface } from "../../../domain/interfaces/user_interface";

export class UserLocalService {
    setMeCached(user: UserInterface): void {
        secureLocalStorage.setItem("userProfile", JSON.stringify(user));
    }
    
    getMeCached(): UserInterface | null {
        const userJson = secureLocalStorage.getItem("userProfile") as string | null;
        if (userJson == null) {
            return null;
        }
        const decodedJson = JSON.parse(userJson);
        if (this.isValidUserInterface(decodedJson)) {
            return decodedJson as UserInterface;
        }
        return null;
    }

    private isValidUserInterface(value: unknown): value is UserInterface {
        if (!value || typeof value !== 'object') {
            return false;
        }
        const obj = value as Record<string, unknown>;
        const experience = obj.experience as Record<string, unknown> | null;
        return typeof obj.userId === 'string' &&
            typeof obj.firstname === 'string' &&
            typeof obj.lastname === 'string' &&
            typeof obj.profilePicture === 'string' &&
            typeof obj.nbExtends === 'number' &&
            typeof obj.experience === 'object' &&
            typeof obj.communication === 'number' &&
            experience !== null &&
            typeof experience.totalExp === 'number' &&
            typeof experience.courseExp === 'number' &&
            typeof obj.nbVibes === 'number' &&
            typeof obj.verified === 'boolean' &&
            typeof obj.banned === 'boolean';
    }

    removeMeCached(): void {
        secureLocalStorage.removeItem("userProfile");
    }
}